<template>
	<div>
		<div class="headSearch">
			<Row type="flex" justify="center" align="middle" class="eateryRow">
				<Col span="6"></Col>
				<Col span="12" style="text-align: center;">
					<Button v-for="(item,index) in btnList" @click="QueryEatery(item)" :key="index" :size="item.size" :type="item.type">{{item.name}}</Button>
				</Col>
				<Col span="6"></Col>
			</Row>
		</div>
		<Table :columns="EateryTH" :data="eateryCurrTable"></Table>
		<Row type="flex" justify="center" align="middle" style="height: 32px;padding: 3px 0px;">
			<Col span="13"></Col>
			<Col span="6" style="text-align: center;">总次数:{{eateryTableSumCount}}次</Col>
			<Col span="5" style="text-align: center;">合计:{{eateryTableSumMoney}}元</Col>
		</Row>
		<div style="width: 100%;height: 32px;text-align: center;">
			<Page
			style="margin-top: 6px;"
			@on-change="eateryPageUpate" 
			@on-page-size-change="eateryPageSizeUpdate" 
			:current="CurrPage"
			:page-size="CurrSize"
			:total="eateryTableTotal"
			/>
		</div>
	</div>
</template>
<script>
    import expandRow from '../table-expand.vue';
    export default {
        components: { expandRow },
        data () {
            return {
				CurrSize:10,
				CurrPage:1,
				btnList:[
					{
						name:'上月',
						type:'info',
						size:'small'
					},
					{
						name:'全部',
						type:'info',
						size:'small'
					},
					{
						name:'当月',
						type:'info',
						size:'small'
					}
				],
                EateryTH: [
                    {
                        type: 'expand',
                        width: 38,
                        render: (h, params) => {
                            return h(expandRow, {
                                props: {
                                    datas: params.row.datas
                                },
								style:{
									width:'100%'
								}
                            })
                        }
                    },
                    {
                        title: '时间',
						align:'center',
						render: (h, params) => {
							return h('div',{},new Date(params.row.ccreatetime).format('yyyy年MM月dd日'));
						}
                    },
                    {
                        title: '数量',
						align:'center',
						width:63,
						render: (h, params) => {
							return h('div',{},params.row.datas.length+'次');
						}
                    },
					{
						title: '金额',
						align:'center',
						width:102,
						render: (h, params) => {
							return h('div',{},(params.row.datas.length*3)+'元');
						}
					},
                ],
                EateryData: [
                ],
				EateryTable:[],
            }
        },
		created:function(){
			this.$http.get("cardrecord/ByCardrecord?openid="+this.$route.query.openid,'').then((res)=> {
				for(let i=0;i<res.data.length;i++){
					res.data[i].count=res.data[i].datas.length;
				}
				this.EateryData=res.data.sort(function(a,b){
					return (new Date(b.ccreatetime))-(new Date(a.ccreatetime));
				});
				this.EateryTable=this.EateryData;
			});
		},
		methods:{
			eateryPageUpate(page){
				this.CurrPage=page;
			},
			eateryPageSizeUpdate(size){
				this.CurrSize=size;
			},
			DateOpertion(date,type,number){
				let y=date.getFullYear();
				let m=date.getMonth();
				let d=date.getDate();
			
				if(type=='add'){
					if(m+number>12){
						y++;
						m=m+number-12;
					}else{
						m+=number;
					}
				}else{
					if(m-number<0){
						y--;
						m=number-m;
					}else{
						m=number;
					}
				}
				return new Date(y,m,d);
			},
			QueryEatery(item){
				item.type='success';
				let datas=this.btnList.filter(b=>b.name!=item.name);
				for(let i=0;i<datas.length;i++){
					if(datas[i].name!=item.name){
						datas[i].type='info';
					}
				}
				
				if(item.name=='全部'){
					this.EateryTable=this.EateryData;
				}else if(item.name=='当月'){
					this.EateryTable=this.EateryData.filter(eatery=>new Date(eatery.ccreatetime).format('yyyy-MM')==new Date().format('yyyy-MM'));
				}else{
					this.EateryTable=this.EateryData.filter(eatery=>this.DateOpertion(new Date(eatery.ccreatetime),'add',1).format('yyyy-MM')==new Date().format('yyyy-MM'));
				}
				this.CurrPage=1;
			}
		},
		computed:{
			eateryTableTotal:function(){
				if(this.EateryTable.length<=this.CurrSize){
					this.CurrPage=1;
				}
				return this.EateryTable.length;
			},
			eateryCurrTable:function(){
				return this.$filterDate(this.EateryTable,this.eateryTableTotal,this.CurrPage,this.CurrSize);
			},
			eateryTableSumCount:function(){
				let sum=0;
				for(let i=0;i<this.EateryTable.length;i++){
					sum+=this.EateryTable[i].datas.length;
				}
				return sum;
			},
			eateryTableSumMoney:function(){
				let sum=0;
				for(let i=0;i<this.EateryTable.length;i++){
					for(let j=0;j<this.EateryTable[i].datas.length;j++){
						sum+=this.EateryTable[i].datas[j].cmoney;
					};
				}
				return sum;
			}
		}
    }
</script>
<style scoped>
	.eateryRow{
		margin: 8px 0px;
	}
	.headSearch{
		width: 100%;
		background: #f8f8f9;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Eatery/Record/index.vue